// upcomingMarkers.js — single source of truth for upcoming lease-date markers.
//
// LEASE-TAB-FIXES-4: Simplified to read only from the criticalDates array.
// Lease-column fallbacks (nextNoticeDeadline, breakDate, renewalNoticeMonths)
// have been removed. The server seeds critical_dates rows (expiration,
// renewal_notice, break_option) on every lease create/update, so criticalDates
// is now the canonical display source for all date types.
//
// getUpcomingMarkers(lease, criticalDates) → array of marker objects that can
// be passed directly to LeaseTimeline as the `criticalDates` prop AND consumed
// by buildDecisionsItems. Both surfaces draw from this function so they always
// agree on which dates exist for a lease.
//
// Shape of each marker:
//   {
//     id:            string   — cd.id (UUID)
//     type:          string   — "renewal_notice" | "break_option" | "escalation" | …
//     dueDate:       string   — ISO-8601 date (YYYY-MM-DD)
//     category_raw:  string|null — human label from critical_dates.category_raw
//     decisionLabel: null     — always null; callers derive labels from category_raw or type
//     description:   string|null — clause text from critical_dates.description
//   }

// eslint-disable-next-line no-unused-vars
export function getUpcomingMarkers(_lease, criticalDates) {
  return (criticalDates || []).map((cd) => ({
    id: cd.id,
    type: cd.type,
    dueDate: cd.dueDate,
    category_raw: cd.categoryRaw ?? cd.category_raw ?? null,
    decisionLabel: null,
    description: cd.description ?? null,
  }));
}
